import type { StartPeriod } from '../db/models'
import { PERIOD_RANGES } from './periodRanges'

/**
 * Die vier **Zeiträume** des Wann- und Ende-Menüs mit ihren Tasten. Hier in `lib/`, weil die Mobile-App
 * dieselbe Sperre „heute schon vorbei“ braucht (Etappe 3). `now` nur für Tests.
 */
export const PERIODS: { key: StartPeriod; shortcut: string }[] = [
  { key: 'morning', shortcut: '3' },
  { key: 'noon', shortcut: '4' },
  { key: 'afternoon', shortcut: '5' },
  { key: 'evening', shortcut: '6' },
]

/** Ist der Zeitraum heute schon vorbei? Zählt ab seiner Endstunde. */
export function isPeriodPastToday(period: StartPeriod, now: Date = new Date()): boolean {
  const [endH] = PERIOD_RANGES[period].end.split(':').map(Number)
  return now.getHours() >= endH!
}

/** Die nächste halbe Stunde als „HH:MM“ (01:14 → „01:30“, 01:45 → „02:00“). */
export function getNextHalfHour(now: Date = new Date()): string {
  let h = now.getHours()
  let m = now.getMinutes()
  if (m < 30) {
    m = 30
  } else {
    m = 0
    h = (h + 1) % 24
  }
  return `${String(h).padStart(2, '0')}:${String(m).padStart(2, '0')}`
}
